import React, { useEffect, useState } from 'react';
import './InTray.scss';
import { DataGrid, Menu, Popup } from 'devextreme-react';
import ApiHelper from '../../helpers/ApiHelper';
import GlobalParams from '../../helpers/GlobalParams';
import { Column, Item } from 'devextreme-react/cjs/data-grid';
import NewClaim from '../NewClaim/NewClaim';

//TODO - display claims / Loans for Popfund for them to get approved


const InTray = () => {

  const [member_name, setMemberName] = useState('');
  const [member_no, setMemberNo] = useState('');
  const [member_id, setMemberId] = useState('');
  const [schemeID, setSchemeID] = useState('');
  const [claimId, setClaimId] = useState('');

  const [popupClaimVisible, setPopupClaimVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [claimsData, setClaimsData] = useState([]);

  const fetchClaims = async (scheme_id) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + 'get-claim-requests?scheme_id=' + scheme_id + 
        "&PopFundAccessLevelId="+GlobalParams.PopFundAccessLevelId+"&portal_user_id="+GlobalParams.ContactPersonId,
        GlobalParams.bearerToken
      );
      setIsLoading(false);
      setClaimsData(result.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    //if (GlobalParams.IsClientLoggedIn) {
      //setIsLoading(true);
      fetchClaims(GlobalParams.schemeStore[0]["schemeID"]);
    //}
  }, []);

  const hideClaimPopup = () => {
    fetchClaims(GlobalParams.schemeStore[0]["schemeID"]);
    setPopupClaimVisible(false);
  }

  const showClaimPopup = () => {
    setPopupClaimVisible(true);
  }

  const onMenuItemClick = (cellInfo, item) => {
    if (item === 'View') {
      setMemberName(cellInfo.data.Names);
      setMemberNo(cellInfo.data.member_no);
      setMemberId(cellInfo.data.MemberId);
      setSchemeID(cellInfo.data.SchemeID);
      setClaimId(cellInfo.data.Id);
      //setEndorseMember({ ...memberStore, scheme_id: cellInfo.data.SchemeID });
      showClaimPopup();
    }
  }

  const actionColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={[
              { text: 'View', icon: 'doc' }
            ]}
          >
          </Item>
        </Menu>
      </div>
    );
  };


  return (
    <div>
      {/*Create Pop Up to view the Claim*/}
      <div>
        {popupClaimVisible && (
          <Popup
            visible={popupClaimVisible}
            title="REQUEST A NEW CLAIM"
            dragEnabled={true}
            showCloseButton={true}
            hideOnOutsideClick={false}
            onHiding={hideClaimPopup}
          >
            <NewClaim
              onClosePopup={hideClaimPopup}
              MemberName={member_name}
              MemberNumber={member_no}
              MemberId={member_id}
              PolicyNo={schemeID}
              claimId={claimId}
              IsApproval={1}
            />
          </Popup>
        )}
      </div>
      <br></br>
      <DataGrid
        dataSource={claimsData}
        wordWrapEnabled={true}
        grouping={
          {
            autoExpandAll: false
          }
        }
        summary={
          {
            groupItems: [
              {
                column: 'Description',
                summaryType: 'count',
                showInGroupFooter: false
              }
            ]
          }
        }
      >
        <Column dataField="Id" visible={false}></Column>
        <Column dataField="SchemeID" visible={false}></Column>
        <Column width={50} caption="" cellRender={actionColumnTemplate} />
        <Column dataField="Claim_Type"></Column>
        <Column dataField="Names" caption='Claimant'></Column>
        <Column dataField="NotificationDate"></Column>
        <Column dataField="ClaimRequestNumber"></Column>
        <Column dataField="Claim_Status"></Column>
      </DataGrid>
    </div>
  );

}
export default InTray;
